import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default function TextArea({
	className,
	id,
	name,
	placeholder,
	rows,
	value,
	...rest
}) {
	const classes = cn('c-textarea', className)

	return (
		<textarea
			className={classes}
			id={id}
			name={name}
			placeholder={placeholder}
			rows={rows}
      value={value}
			{...rest}
		/>
	)
}

TextArea.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	rows: PropTypes.number,
	value: PropTypes.string
}

TextArea.defaultProps = {
	className: '',
	placeholder: '',
	rows: 3,
	value: ''
}
